import { useState } from "react";

import { Menu, Button, Group } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useLocation, Link, Outlet } from "react-router-dom";
import { IconApps, IconLogout, IconSettings, IconMenu2, IconActivity, IconChartBar } from "@tabler/icons-react";

import { useUser } from "./auth/hooks";
import { logout } from "./auth/api";
import AppShellComponent from "./components/AppShell";

type NavBarItemProps = {
  to: string;
  text: string;
  isMobile: boolean | undefined;
};

export const NavBarItem: React.FC<NavBarItemProps> = ({
  to,
  text,
  isMobile,
}) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);
  return (
    <Link to={to}>
      <Button
        variant={isActive ? "filled" : "outline"}
        size={isMobile ? "sm" : "md"}
      >
        {text}
      </Button>
    </Link>
  );
};

export default function Root() {
  const user = useUser();

  const isMobile = useMediaQuery("(max-width: 48em)");

  const [opened, setOpened] = useState(false);

  return (
    <AppShellComponent
      navItems={
        <Group gap="xs" wrap="nowrap">
        <Menu position="bottom-start" shadow="md" width={210}>
          <Menu.Target>
            <Button variant="outline" aria-label="Open navigation" size={isMobile ? "sm" : "md"}>
              <IconMenu2 size={20} />
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Menu.Item leftSection={<IconActivity size={16} />}>Health Checks</Menu.Item>
            </Link>
            <Link to="/backtest-audit/features" style={{ textDecoration: "none" }}>
              <Menu.Item leftSection={<IconChartBar size={16} />}>Backtest Audit</Menu.Item>
            </Link>
          </Menu.Dropdown>
        </Menu>
        <Menu
          position="bottom-end"
          shadow="md"
          width={200}
          opened={opened}
          onChange={setOpened}
        >
          <Menu.Target>
            <Button
              variant={opened ? "filled" : "outline"}
              size={isMobile ? "sm" : "md"}
            >
              Account
            </Button>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>{user?.email}</Menu.Label>
            <Link to="/manage-notifications" style={{ textDecoration: "none" }}>
              <Menu.Item leftSection={<IconSettings size={14} />}>
                Manage Notifications
              </Menu.Item>
            </Link>
            <Link to="/manage-apps" style={{ textDecoration: "none" }}>
              <Menu.Item leftSection={<IconApps size={14} />}>
                Manage Apps
              </Menu.Item>
            </Link>
            <Menu.Item
              color="red"
              leftSection={<IconLogout size={14} />}
              onClick={logout}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
        </Group>
      }
    >
      <Outlet />
    </AppShellComponent>
  );
}
